<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-1">
        <h6 class="modal-title" i18n>Attribute Descriptions</h6>
        <div class="flex-fill"></div>
        <button (click)="onSave(form)" type="button" class="btn btn-secondary-info">
          <span class="cs-icon cs-icon-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="mx-3 mt-3">
      <div [formGroup]="form" class="row">
        <div class="col-sm-3">
          <mat-form-field2 [showLabel]="false" matTooltip="Entity Type" i18n-matTooltip>
            <mat-select formControlName="entity_type" placeholder="Entity Type" i18n-placeholder>
              <mat-option *ngFor="let item of dataEntityTypes" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="container-box p-3">
        <form [formGroup]="form">
          <div formArrayName="attributes" *ngFor="let item of attributesArrayForm.controls; let i = index">
            <div [formGroupName]="i" class="row">
              <div class="col-sm-3">
                <mat-form-field2 class="mat-block">
                  <input type="text" formControlName="label" placeholder="Name" i18n-placeholder matInput required />
                  <mat-error *ngIf="item.get('label').touched && item.get('label').hasError('required')">
                    <ng-container i18n>Name is required</ng-container>
                  </mat-error>
                  <mat-error *ngIf="item.get('label').hasError('duplicated')">
                    <ng-container i18n>Name is duplicated</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-sm-3">
                <mat-form-field2 class="mat-block">
                  <mat-select formControlName="field_type" placeholder="Data Type" i18n-placeholder required>
                    <mat-option [value]="item.value" *ngFor="let item of fieldTypes">{{ item.label }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="item.get('field_type').touched && item.get('field_type').hasError('required')">
                    <ng-container i18n>Data Type is required</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-sm-5">
                <mat-form-field2 class="mat-block">
                  <input
                    type="text"
                    formControlName="description"
                    placeholder="Description"
                    i18n-placeholder
                    matInput
                  />
                </mat-form-field2>
              </div>
              <div class="col-sm-1">
                <button
                  (click)="removeAttr(i)"
                  matTooltip="Remove this attribute"
                  i18n-matTooltip
                  class="btn btn-secondary-danger align-input-row-end"
                  type="button"
                >
                  <i class="cs-icon cs-icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="d-flex align-items-center gap-3 mt-3">
        <button (click)="addAttr()" class="btn btn-secondary-info" type="button">
          <i class="far fa-plus"></i> <ng-container i18n>Add Attribute</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
